import React, { useState } from 'react';
import './index.scss';

import CollectMapApi from '@/fetch/bussiness/collectMap';
import CollectTaskModal from '@/components/CollectTaskModal';

const fetchApi = new CollectMapApi();

const CheckCollectRoute = (props: {
  vehicleName: string;
  cockpitNumber: string;
}) => {
  const { cockpitNumber, vehicleName } = props;
  const [taskListModal, setTaskListModal] = useState<boolean>(false);
  return (
    <>
      <li
        className={'btn-item check-collect-map'}
        onClick={() => {
          setTaskListModal(true);
        }}
      >
        <i>采集线路</i>
      </li>
      <CollectTaskModal
        visible={taskListModal}
        setVisible={setTaskListModal}
        cockpitNumber={cockpitNumber}
        vehicleName={vehicleName}
      />
    </>
  );
};

export default React.memo(CheckCollectRoute);
